import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-wrap gutter-y-s3 flex-grow-1 xl:justify-content-center" }
const _hoisted_2 = { class: "w-12 sm:w-4 xl:col-offset-1" }
const _hoisted_3 = { class: "flex mr-s2 align-items-center" }
const _hoisted_4 = { class: "w-12 sm:w-4 lg:w-3" }
const _hoisted_5 = { class: "mr-s2 flex align-items-center" }
const _hoisted_6 = { class: "mr-s1" }
const _hoisted_7 = { class: "w-12 sm:w-4 lg:w-3" }
const _hoisted_8 = { class: "mr-s2 flex align-items-center" }
const _hoisted_9 = { class: "mr-s1" }
const _hoisted_10 = { class: "grid grid-nogutter" }
const _hoisted_11 = { class: "col-12 xl:col-9 xl:flex-order-2" }
const _hoisted_12 = { class: "col-12 xl:col-3 xl:pr-s3 mt-s3 xl:mt-s0" }

import { useI18n } from 'vue-i18n';
import { computed, toRef } from 'vue';
import roundMixin from '@/mixins/round.mixin';
import { formatNumbersMixin } from '@/mixins/format-numbers.mixin';
import { getScanLink } from '@/sdk/utils';
import { DEFAULT_NETWORK_ID } from '@/helpers/networkParams.helper';
import { ENABLE_FAKE_CARDANO_NETWORK } from '@/helpers/fakeCardanoNetwork';
import TokenIcon from '@/components/token/TokenIcon.vue';
import ControlPanelCollapse from '@/components/ControlPanelCollapse.vue';
import InfoMessage from '@/components/InfoMessage.vue';
import PoolTitle from './poolTitle/PoolTitle.vue';
import Caption from '@/components/Caption.vue';
import Collect from './collect/Collect.vue';
import Stake from './stake/Stake.vue';
import { Staking } from '@/sdk/entities/staking';
import { useMilkomedaWSCBalanceADAIntoCardanoValidator } from '@/composables/milkomeda-wrapped-smartcontract/useMilkomedaWSCBalanceADAIntoCardanoValidator';
import { useTokens } from '@/store/modules/tokens/useTokens';


export default /*#__PURE__*/_defineComponent({
  __name: 'Pool',
  props: {
    pool: null
  },
  emits: ["sendTransaction"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'sendTransaction'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  pool: Staking;
}

const { mathMixRound } = roundMixin.methods;
const { format } = formatNumbersMixin.methods;
const { t } = useI18n();
const { getTokenByAddressAndChainId } = useTokens();





const token = computed(() =>
  getTokenByAddressAndChainId(props.pool.tokenToMint, +DEFAULT_NETWORK_ID!),
);
const balanceADAIntoCardanoValidator = useMilkomedaWSCBalanceADAIntoCardanoValidator();

const isValidCardanoBalanceRef = toRef(
  balanceADAIntoCardanoValidator.milkomedaWSCBalanceADAIntoCardanoValidatorState,
  'isValidCardanoBalance',
);
const minADABalanceRef = toRef(
  balanceADAIntoCardanoValidator.milkomedaWSCBalanceADAIntoCardanoValidatorState,
  'minADABalance',
);

const isShowNotEnoughCurrencyForFee = computed(
  () => ENABLE_FAKE_CARDANO_NETWORK && !isValidCardanoBalanceRef.value,
);

function printPercent(val) {
  if (val.lt(1)) {
    return `< 1%`;
  }
  return val.gt(10000) ? `> 10000%` : `${mathMixRound(val, 2)}%`;
}

function getContractUrl() {
  return getScanLink(props.pool.farm, 'address');
}

function onSendTransaction() {
  emits('sendTransaction');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ControlPanelCollapse, {
    "contract-url": getContractUrl(),
    "toggle-inline": ""
  }, {
    "header-title": _withCtx(() => [
      _createVNode(PoolTitle, {
        "token-name": _unref(token).name,
        "is-syrup": __props.pool.isSyrupPool
      }, null, 8, ["token-name", "is-syrup"])
    ]),
    "header-data": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(Caption, {
            caption: _unref(t)('yieldPool.manual.apr.caption'),
            tooltip: _unref(t)('yieldPool.manual.apr.tooltip'),
            class: "mb-s1"
          }, null, 8, ["caption", "tooltip"]),
          _createElementVNode("div", _hoisted_3, _toDisplayString(printPercent(__props.pool.printApr)), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(Caption, {
            caption: _unref(t)('yieldPool.manual.totalStake.caption'),
            tooltip: _unref(t)('yieldPool.manual.totalStake.tooltip', { token: _unref(token).symbol }),
            class: "mb-s1 md:mb-s1"
          }, null, 8, ["caption", "tooltip"]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(format)(__props.pool.printTotalStake)), 1),
            _createVNode(TokenIcon, {
              "icon-src": _unref(token).tokenIconUrl,
              symbol: _unref(token).symbol,
              size: "12"
            }, null, 8, ["icon-src", "symbol"])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(Caption, {
            caption: _unref(t)('yieldPool.manual.newEarnings.caption'),
            tooltip: _unref(t)('yieldPool.manual.newEarnings.tooltip'),
            class: "mb-s1 md:mb-s1"
          }, null, 8, ["caption", "tooltip"]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(format)(__props.pool.printYouEarned)), 1),
            _createVNode(TokenIcon, {
              "icon-src": _unref(token).tokenIconUrl,
              symbol: _unref(token).symbol,
              size: "12"
            }, null, 8, ["icon-src", "symbol"])
          ])
        ])
      ])
    ]),
    default: _withCtx(() => [
      (_unref(isShowNotEnoughCurrencyForFee))
        ? (_openBlock(), _createBlock(InfoMessage, {
            key: 0,
            type: "error",
            "as-panel": "",
            class: "mb-s3"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('wrappedContract.notEnoughCurrencyForFee', { amount: _unref(minADABalanceRef), symbol: 'ADA' })), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(Stake, {
            pool: __props.pool,
            "wsc-ada-validator": _unref(balanceADAIntoCardanoValidator),
            class: "h-full",
            onSendTransaction: onSendTransaction
          }, null, 8, ["pool", "wsc-ada-validator"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(Collect, {
            pool: __props.pool,
            class: "h-full",
            onSendTransaction: onSendTransaction
          }, null, 8, ["pool"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["contract-url"]))
}
}

})